<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 17:42:37
 * @LastEditTime: 2022-06-06 14:00:51
-->
<template>
  <div>
      <slot name="cd" v-if="HOSPITAL.domain=='cd'">
      </slot>
      <slot name="sz" v-else-if="HOSPITAL.domain=='sz'">
      </slot>
      <slot name="hf" v-else-if="HOSPITAL.domain=='hf'">
      </slot>
      <slot name="common">
      </slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default{
  name:"Common",
  data(){
    return {

    }
  },
  computed: mapGetters({
    HOSPITAL: "getHospital",
  }),
  created(){
  }
}
</script>
<style lang="less" scoped>

</style>